import ModalTrigger from './ModalTrigger';
export default ModalTrigger;